<div *ngIf="units">
	<div class="preview" *ngIf="!units"></div>
	<div class="preview" *ngIf="selected_unit" [ngClass]="{parking: selected_unit.parking, covered: selected_unit.parking && !is_open_parking(selected_unit)}">
		<img [src]="'/assets/units/'+selected_unit.dim+'.jpg'" onerror="this.src = '/assets/units/no-image.png'" />
		<p *ngIf="!selected_unit.parking" class="view-3d" (click)="view_3d_click()">
			View 3D
			<svg xmlns="http://www.w3.org/2000/svg" width="41.058" height="41" viewBox="0 0 41.058 41"><defs><style>.a{fill:#0d874f;}</style></defs><g transform="translate(-2.481 -2.549)"><path class="a" d="M39.509,8.536a20.483,20.483,0,0,0-27.621-1.21L9.467,4.905a1.239,1.239,0,0,0-1.254-.3,1.285,1.285,0,0,0-.865.951L5.965,13.334a1.234,1.234,0,0,0,.346,1.124,1.285,1.285,0,0,0,.865.346h.216l7.781-1.426a1.219,1.219,0,0,0,.951-.865,1.341,1.341,0,0,0-.3-1.254l-2.2-2.2A18.043,18.043,0,0,1,42.707,26.431,1.241,1.241,0,0,0,43.7,27.9a1.872,1.872,0,0,1,.216.043,1.212,1.212,0,0,0,1.21-1.037A20.466,20.466,0,0,0,39.509,8.536Zm-30.777,3.5L9.38,8.363l2.983,2.983Z" transform="translate(-1.963 0)"/><path class="a" d="M40.614,51.824,32.834,53.25a1.218,1.218,0,0,0-.951.865,1.341,1.341,0,0,0,.3,1.254l2.2,2.2A18.036,18.036,0,0,1,5.3,40.24a1.255,1.255,0,1,0-2.464-.475A20.531,20.531,0,0,0,23.021,64.1a20.178,20.178,0,0,0,13.1-4.8L38.5,61.679a1.373,1.373,0,0,0,.865.346,1.2,1.2,0,0,0,.389-.043,1.285,1.285,0,0,0,.865-.951l1.426-7.781a1.234,1.234,0,0,0-.346-1.124A1.588,1.588,0,0,0,40.614,51.824Zm-1.988,6.441L35.6,55.282l3.674-.648Z" transform="translate(0 -20.551)"/><path class="a" d="M36.139,46.51a1.1,1.1,0,0,0,1.037,0l8.9-4.063a1.287,1.287,0,0,0,.735-1.124V30.517a1.238,1.238,0,0,0-.735-1.124l-8.9-4.063a1.1,1.1,0,0,0-1.037,0l-8.9,4.063a1.287,1.287,0,0,0-.735,1.124V41.28a1.238,1.238,0,0,0,.735,1.124Zm8.17-6.008-6.4,2.939V35.4l6.4-2.939ZM36.658,27.837l5.879,2.68L36.658,33.24l-5.879-2.68Zm-7.651,4.625L35.4,35.4v8l-6.4-2.939Z" transform="translate(-13.637 -12.86)"/></g></svg>
		</p>
		<div class="specials">
			<ng-container *ngIf="false">
				<p *ngIf="selected_unit.on_sale">On sale today!</p>
				<p *ngIf="selected_unit.one_left">Only 1 left!</p>
				<p *ngIf="selected_unit.free_month">One month free!</p>
			</ng-container>
			<p *ngIf="selected_unit.on_sale" class="new one-day-only">
				<span>
					One day <b>only</b>
				</span>
			</p>
			<ng-container *ngIf="true || !selected_unit.on_sale">
				<p class="new" *ngIf="selected_unit.first_month_free">
					<img [src]="'assets/1st-month-free.svg'">
					<span>
						One month <b>Free</b>
					</span>
				</p>
				<p class="new" *ngIf="selected_unit.one_month_half_price && !selected_unit.three_month_half_price && !selected_unit.first_month_free">
					<img [src]="'assets/50-off-first-month.svg'">
					<span>
						<b>50% off</b> your first month!
					</span>
				</p>
				<p class="new" *ngIf="selected_unit.three_month_half_price">
					<img [src]="'assets/50-off-first-3-months.svg'">
					<span>
						<b>50% off</b> your first three months!
					</span>
				</p>
				<p class="new" *ngIf="selected_unit.few_left && !selected_unit.one_month_half_price && !selected_unit.three_month_half_price && !selected_unit.first_month_free">
					<b>Few left!</b>
				</p>
			</ng-container>
		</div>

		<nav *ngIf="stage < 3 && selected_unit">
			<p class="prev" (click)="change(-1)" *ngIf="next_unit(-1) != null"></p>

			<p>{{selected_unit.dim}}: {{selected_unit.area|number:'0.0-2':'en-ZA'}}m²</p>

			<p class="next" (click)="change(1)" *ngIf="next_unit(1) != null"></p>
		</nav>
	</div>
	<div class="details">
		<div class="section" [ngClass]="{active: stage == 1 || (selected_unit && !selected_unit.unlocked), complete: stage > 1 && (selected_unit && selected_unit.unlocked)}">
			<h1 *ngIf="stage <= 1 || (selected_unit && !selected_unit.unlocked)">1. Select unit</h1>
			<h1 *ngIf="stage > 1 && (selected_unit && selected_unit.unlocked)" class="clickable" (click)="back_to_stage(1)">1. Unit size: {{selected_unit.dim}}: {{selected_unit.area|number:'0.0-2':'en-ZA'}}m² | {{selected_unit.desc}}</h1>
			<div>
				<ng-container *ngIf="!!units">
					<h2>Select an alternative unit size from the dropdown below</h2>
					<ras-unit-dropdown [units]="units" [(selected)]="unit_size_index" (change)="selected_unit = $event"></ras-unit-dropdown>
					<nav>
						<p (click)="change(-1)"><ng-container *ngIf="next_unit(-1) != null">&lt; Smaller unit</ng-container></p>
						<p (click)="change(+1)"><ng-container *ngIf="next_unit(+1) != null">Larger unit &gt;</ng-container></p>
					</nav>
					<p>
						<b>{{selected_unit.desc}}</b>
						<ng-container *ngIf="!selected_unit.parking && !!get_estimate(selected_unit)"><br> {{get_estimate(selected_unit)}}</ng-container>
<!--
						<ng-container *ngIf="selected_unit.sizerank == 'small'"><br>Can hold contents of a large cupboard</ng-container>
						<ng-container *ngIf="selected_unit.sizerank == 'medium'"><br>Can hold contents of approximately 2 to 5 rooms</ng-container>
						<ng-container *ngIf="selected_unit.sizerank == 'large'"><br>Can hold contents of approximately 6 to 8 rooms</ng-container>
 -->
					</p>
					<ng-container *ngIf="!selected_unit.parking">
						<p class="information" *ngIf="selected_unit.truck">
							<img alt="" [src]="'assets/iconTruckGreenBG.svg'">{{' '}}
							<img alt="" [src]="'assets/iconTrailerGreenBG.svg'">{{'&ensp;'}}
							Free move-in truck &amp; driver or trailer
						</p>
						<p class="information" *ngIf="!selected_unit.truck">
							<img alt="" [src]="'assets/iconTrailerGreenBG.svg'">{{'&ensp;'}}
							Free move-in trailer
						</p>
					</ng-container>
					<hr>
					<ng-container *ngIf="!otp_sent && (!cell_number || (selected_unit && !selected_unit.unlocked))">
						<h2 class="instruction" [ngClass]="{bounce: bouncing_cell_prompt}">Get a quick quote</h2>
						<form>
							<p class="row two-cols">
								<span class="col">
									<label>First Name *</label>
									<input name="quote_first_name" type="text" [(ngModel)]="first_name" [ngClass]="{invalid: !valid_first_name()}">
									<span class="validation" *ngIf="show_invalid && !valid_first_name()">Please provide your name</span>
								</span>
								<span class="col">
									<label>Last name *</label>
									<input name="quote_last_name" type="text" [(ngModel)]="last_name" [ngClass]="{invalid: !valid_last_name()}">
									<span class="validation" *ngIf="show_invalid && !valid_last_name()">Please provide your name</span>
								</span>
							</p>
							<p>
								<label>Email *</label>
								<input name="quote_email" type="text" [(ngModel)]="email" [ngClass]="{invalid: !valid_email()}">
								<span class="validation" *ngIf="show_invalid && !valid_email()">Please provide a valid email address</span>
							</p>
							<p>
								<label>Cellphone number *</label>
								<input id="cell_number" [ngClass]="{'invalid': !valid_phone_number()}" type="text" [(ngModel)]="entered_cell_number" name="cell_number" placeholder="Enter your mobile number here for an OTP">
								<span class="validation" *ngIf="show_invalid && !valid_phone_number()">Please enter a valid South African phone number</span>
							</p>

							<p class="newsletter-signup">
								<label class="checkbox-label">
									<input type="checkbox" [(ngModel)]="newsletter_signup" name="newsletter_signup">
									<span>Please send me email updates and newsletters from Rent-A-Store</span>
								</label>
							</p>

							<p class="privacy-note">
								<a [routerLink]="['/privacy-statement']" target="_blank">Privacy statement</a>: Your mobile number will only be used to obtain pricing and for any rental support you might require.
							</p>

							<button [disabled]="busy_sending_otp" (click)="initiate_captcha()">
								<span class="spinner" *ngIf="busy_sending_otp"></span>
								Get OTP
							</button>
							<!--<div>
								<p class="footnote"><a [routerLink]="['/privacy-statement']" target="_blank">Privacy statement</a>: Your mobile number will only be used to obtain pricing and for any rental support you might require.</p>
							</div>-->
						</form>
					</ng-container>
					<ng-container *ngIf="otp_sent && !in_progress  && (!cell_number || (selected_unit && !selected_unit.unlocked))">
						<p class="instruction"><b>Enter OTP sent to mobile no. {{ entered_cell_number | slice:0:3}}****{{ entered_cell_number | slice:7}}</b></p>
						<p class="otp">
							<input type="text" maxlength="1" (focus)="$event.target.select()" (input)="otp_input($event, 0)" [(ngModel)]="otp_digits[0]" autofocus>
							<input type="text" maxlength="1" (focus)="$event.target.select()" (input)="otp_input($event, 1)" [(ngModel)]="otp_digits[1]">
							<input type="text" maxlength="1" (focus)="$event.target.select()" (input)="otp_input($event, 2)" [(ngModel)]="otp_digits[2]">
							<input type="text" maxlength="1" (focus)="$event.target.select()" (input)="otp_input($event, 3)" [(ngModel)]="otp_digits[3]">
						</p>
						<p>
							<a (click)="resend_otp()">Re-send OTP</a>
						</p>
					</ng-container>
					<ng-container *ngIf="cell_number && selected_unit && selected_unit.unlocked">
						<p>You have already unlocked the price for this unit</p>
						<button (click)="show_price()">View price</button>
					</ng-container>
				</ng-container>
			</div>
		</div>

		<div class="section" [ngClass]="{active: stage == 2 && selected_unit.unlocked, complete: stage > 2}">
			<h1 *ngIf="stage <= 2" (click)="bounce_cell_prompt()">2. Get price</h1>
			<h1 *ngIf="stage > 2" class="clickable" (click)="back_to_stage(2)">2. Price: R{{selected_unit.rate|number:'0.0-0'}}pm</h1>
			<div>
				<ng-container *ngIf="selected_unit && !selected_unit.unlocked">
					<p><a (click)="back_to_stage(1)">Go back</a> and get an OTP to unlock the price for this unit</p>
				</ng-container>
				<ng-container *ngIf="selected_unit && selected_unit.unlocked">
					<p class="price">R{{selected_unit.rate|number:'0.0-0'}}<small> monthly incl. VAT</small></p>
					<ng-container *ngIf="selected_unit.first_month_free">
						<p class="special-price">Second month: R0.00 incl. VAT</p>
						<p class="special-price" *ngIf="selected_unit.three_month_half_price">Next 2 months: R{{(selected_unit.rate * 0.5)|number:'0.2-2'}} incl. VAT</p>
					</ng-container>
					<ng-container *ngIf="!selected_unit.first_month_free">
						<p class="special-price" *ngIf="selected_unit.one_month_half_price && !selected_unit.three_month_half_price">First month: R{{(selected_unit.rate * 0.5)|number:'0.2-2'}} incl. VAT</p>
						<p class="special-price" *ngIf="selected_unit.three_month_half_price">First 3 months: R{{(selected_unit.rate * 0.5)|number:'0.2-2'}} incl. VAT</p>
					</ng-container>
					<nav>
						<p (click)="change(-1)"><ng-container *ngIf="next_unit(-1) != null">&lt; Smaller unit</ng-container></p>
						<p (click)="change(+1)"><ng-container *ngIf="next_unit(+1) != null">Larger unit &gt;</ng-container></p>
					</nav>
					<p *ngIf="!selected_unit.parking && !selected_unit.truck"><img [src]="'assets/iconTrailer.svg'" alt="" width="35px"> {{'&emsp;'}} Free move-in trailer</p>
					<p *ngIf="!selected_unit.parking && selected_unit.truck"><img [src]="'assets/iconTruck.svg'" alt="" width="35px"> {{'&emsp;'}} Free move-in truck &amp; driver or trailer</p>
					<p><img [src]="'assets/iconCard.svg'" alt="" width="35px"> {{'&emsp;'}} No deposit / move-in fees</p>
					<!-- <p><img *ngIf="!selected_unit.parking" [src]="'assets/iconBox.svg'" alt="" width="35px"> {{'&emsp;'}} 10 free boxes worth R230</p> -->
					<hr>
					<p class="instruction">
						<b>Reserve now, pay later!</b>
						No reservation or cancellation fees.
					</p>
					<button (click)="reserve_now()">Reserve now</button>
				</ng-container>
			</div>
		</div>

		<div class="section" [ngClass]="{active: stage == 3}">
			<h1>3. Reserve your unit</h1>
			<div [ngClass]="{'show-invalid': show_invalid}">
				<p>Enter your details to secure your unit</p>
				<p class="row two-cols">
					<span class="col">
						<label>First Name</label>
						<input type="text" [(ngModel)]="first_name" [ngClass]="{invalid: !valid_first_name()}">
						<span class="validation" *ngIf="show_invalid && !valid_first_name()">Please provide your name</span>
					</span>
					<span class="col">
						<label>Last name</label>
						<input type="text" [(ngModel)]="last_name" [ngClass]="{invalid: !valid_last_name()}">
						<span class="validation" *ngIf="show_invalid && !valid_last_name()">Please provide your name</span>
					</span>
				</p>
				<p>
					<label>Email</label>
					<input type="text" [(ngModel)]="email" [ngClass]="{invalid: !valid_email()}">
					<span class="validation" *ngIf="show_invalid && !valid_email()">Please provide a valid email address</span>
				</p>
				<p>
					<label>Nationality *</label>
				</p>
				<p>
					<label><input type="radio" name="nationality" [(ngModel)]="nationality" value="sa"> South African citizen</label>
					{{'&emsp;'}}
					<label><input type="radio" name="nationality" [(ngModel)]="nationality" value="foreign"> Foreign national</label>
					<span class="validation" *ngIf="show_invalid && !valid_nationality()">Please select your nationality to proceed</span>
				</p>
				<p *ngIf="nationality == 'sa'">
					<label>Your South African ID number *</label>
					<input type="text" [(ngModel)]="id_number" [ngClass]="{invalid: show_invalid && !valid_id_number()}" maxlength="13">
					<span class="validation" *ngIf="show_invalid && !valid_id_number()">{{id_number_error_message()}}</span>
				</p>
				<p>Are you reserving the unit as an individual or on behalf of a business?</p>
				<p>
					<label><input type="radio" name="tenant_type" [(ngModel)]="tenant_type" value="individual"> Individual </label>
					{{'&emsp;'}}
					<label><input type="radio" name="tenant_type" [(ngModel)]="tenant_type" value="business"> Business</label>
					<span class="validation" *ngIf="show_invalid && !valid_tenant_type()">Please select one of the options above</span>
				</p>
				<p>
					<label>Move-in date</label>
					<ras-date [(date)]="move_in_date" [invalid]="!valid_move_in_date()" [min_date]="location.earliestMoveIn"></ras-date>
					<span class="validation" *ngIf="show_invalid && !valid_move_in_date()">Please select a move-in date</span>
				</p>
				<p>
					<button (click)="reserve()" [disabled]="busy_reserving">Reserve unit</button>
				</p>
			</div>
		</div>

	</div>
</div>

<ras-spinner [active]="in_progress || busy_reserving || busy_loading" [messages]="busy_loading ? ['Retrieving list of available units'] : busy_reserving ? ['Contacting the booking system', 'Creating a reservation', 'Preparing confirmation email', 'Verifying'] : busy_checking ? ['Checking for existing reservations'] : busy_cancelling ? ['Replacing old reservation'] : null"></ras-spinner>

<ras-popup *ngIf="!!error_message" (close)="error_message = null" error>
	<p>{{error_message}}</p>
</ras-popup>
